angular.module('zc.projects')

.directive 'campaignGroups', (CampaignStats, Project, currencies) ->
  restrict: 'E'
  scope: {
    project: '='
    campaign: '='
    filters: '='
  }
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_groups.html'

  link: (scope, element, attrs) ->
    scope.Project = Project
    scope.currency = currencies[scope.project.currency]
    updateData = ->
      CampaignStats.aggregate
        dimension: 'daily'
        campaign_id: scope.campaign.id
        apikey: scope.campaign.apikey
        start_at: scope.filters.start_at
        end_at: scope.filters.end_at
      .then (campaign_stats) ->
        scope.stats = CampaignStats.groupById(campaign_stats)[scope.campaign.id]
    scope.$watch 'filters', updateData, true



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/campaign_groups.coffee